<template>
  <div>
    <table-card
      ref="datatable"
      module="ImeiAssignment"
      :headers="headers"
      :actions="actions"
      :filters="filters"
    >
      <template v-slot:action>
        <vs-button color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Import Imei</vs-button>
      </template>
    </table-card>

    <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
      <template>
        <vs-divider class="mt-0">Imei Template</vs-divider>
          <div class="vx-col w-full mt-0">
            <vs-button id="downloadBtn" style="width: 100%" color="rgb(147, 147, 147)" type="filled" icon-pack="feather" icon="icon-download" class="pl-5 mt-1 vs-con-loading__container" @click="download">Download File</vs-button>
          </div>
        <vs-divider>Import Imei</vs-divider>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full required">
            <label class="vs-input--label">Branch</label>
            <v-select :clearable="false" :options="branchList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" v-model="input.branch" />
          </div>
          <!-- <div class="vx-col sm:w-1/2 w-full required">
            <label class="vs-input--label">Gps Type</label>
            <v-select :clearable="false" :options="gpsList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" v-model="input.gps_type" />
          </div> -->
          <div class="vx-col sm:w-1/2 w-full required">
            <label class="vs-input--label">File</label>
            <input type="file" label="File" ref="excel" class="w-full file-input" @change="handleFile('excel')"/>
            <span style="color: red; font-style: italic; font-size:11px">*Import file berdasarkan template imei diatas</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button :disabled="isSubmit" id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
            <vs-button :disabled="isSubmit" v-show="action === 'store'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
          </div>
        </div>

        <!-- <div class="vx-row" v-if="typeof importResponse.success != 'undefined' && typeof importResponse.fail != 'undefined'"> -->
        <div class="vx-row" v-if="(typeof importResponse.success) != 'undefined' && (typeof importResponse.fail) != 'undefined'">
          <div class="vx-col w-full ml-auto">
            <vs-divider>RESULT</vs-divider>
            <table class="table mt-1">
              <thead>
                <tr>
                  <th colspan="2" class="text-center bg-success text-white">Success ({{ importResponse.success.length }})</th>
                </tr>
                <tr>
                  <th>No</th>
                  <th>Imei</th>
                </tr>
              </thead>
              <tbody v-if="importResponse.success.length > 0">
                <tr v-for="(item, index) in importResponse.success" :key="index">
                  <td>{{ index+1 }}</td>
                  <td>{{ item }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="text-center">No successful Import</td>
                </tr>
              </tbody>
            </table>

            <vs-button v-if="importResponse.fail.length > 0" id="exportBtn" icon-pack="feather" icon="icon-file-text" color="danger" type="border" class="mb-4 md:mb-0 vs-con-loading__container" @click="ExportFailData">Export</vs-button>

            <table class="table mt-1">
              <thead>
                <tr>
                  <th colspan="4" class="text-center bg-danger text-white">Failed ({{ importResponse.fail.length }})</th>
                </tr>
                <tr>
                  <th>No</th>
                  <th>Imei</th>
                  <th>Serial Number</th>
                  <th>Error Message</th>
                </tr>
              </thead>
              <tbody v-if="importResponse.fail.length > 0">
                <tr v-for="(item, index) in importResponse.fail" :key="index">
                  <td>{{ index+1 }}</td>
                  <td>{{ item.imei }}</td>
                  <td>{{ item.serial_number }}</td>
                  <td>{{ item.message }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="text-center">No failed Import</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </vs-popup>
  </div>

</template>

<script>
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'
import TableCard from '@/components/TableCard'

export default {
  components: {
    vSelect,
    TableCard,
  },

  data () {
    return {
      showPopup: false,
      popupTitle: '',
      action: '',
      isSubmit: false,
      input: {
        id: null,
        branch: null,
        gps_type: null,
        excel: null,
      },
      file: {},
      importResponse: {}
    }
  },

  computed: {
    headers() {
      return [
        [
          { label: 'Branch', value: 'ref_branch.name' },
          { label: 'Gps Type', value: 'ref_gps_type.name' },
          { label: 'SN', value: 'sn' },
          { label: 'Imei', value: 'imei' },
          { label: 'Installed Date', value: 'installed_date' },
        ]
      ]
    },
    actions() {
      return [
        { name: 'Delete', action: this.del, icon: 'icon-trash', color: 'danger', condition: this.showDelete },
      ]
    },
    filters() {
      return [
        [
          { name: 'branch_id', label: 'Branch', options: this.branchList, width: '1/2', type: 'select' },
          { name: 'gps_type_id', label: 'Gps Type', options: this.gpsList, width: '1/2', type: 'select' },
        ],
      ]
    },
    actor() {
      return this.$store.state.User.profile
    },
    gpsList() {
      return this.$store.state.GpsType.select
    },
    branchList() {
      return this.$store.state.Branch.select
    },
  },

  watch: {},

  async created () {
    await this.$store.dispatch('User/profile')
    await this.$store.dispatch('Branch/select')
    await this.$store.dispatch('GpsType/select')
  },

  mounted () {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },

    reset(clearResponse = false) {
      Object.keys(this.input).map(item => {
        this.input[item] = null
      })
      this.$refs['excel'].value = ''
      if(clearResponse) this.importResponse = {}
    },

    add() {
      this.reset(true)
      this.action = 'store'
      this.popupTitle = 'Import Imei'
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')

      const data = new FormData()
      data.append('branch_id', this.input.branch !== '' ? this.input.branch.value : '')
      if(typeof this.file.excel !== 'undefined') data.append('excel', this.file.excel)
      
      const {status, message} = await this.$store.dispatch('ImeiAssignment/import', data)
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if(status) {
        this.importResponse = message.data
        this.initTable()
        this.reset()
      }
    },

    async download() {
      const {status, message} = await this.$store.dispatch('Imei/template')
      const filename = `Template_Imei.xlsx`
      if (status) FileDownload(message, filename)
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Imei`,
        text: 'Are you sure want to delete this imei ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const {status, message} = await this.$store.dispatch('ImeiAssignment/delete', this.input.id)
      if(status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    handleFile(key) {
      this.file[key] = this.$refs[key].files[0]
    },

    async ExportFailData() {
      const {status, message} = await this.$store.dispatch('Imei/exportResponse', JSON.stringify(this.importResponse.fail))
      const filename = `Import_Fail_Data.xlsx`
      if (status) FileDownload(message, filename)
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },
    
    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },

    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    },

    showDelete(data) {
      return !data.installed_date
    },
  },
}

</script>
